var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var ClassType;
(function (ClassType) {
    ClassType["TAG"] = "CLASS.TAG";
    ClassType["SHEET_ROW"] = "CLASS.SHEET_ROW";
    ClassType["DOCUMENT"] = "CLASS.DOCUMENT";
})(ClassType || (ClassType = {}));
export var EntityType;
(function (EntityType) {
    EntityType["TAG"] = "ENTITY.TAG";
    EntityType["SHEET_ROW"] = "ENTITY.SHEET_ROW";
    EntityType["DOCUMENT"] = "ENTITY.DOCUMENT";
})(EntityType || (EntityType = {}));
export var ClassAction;
(function (ClassAction) {
    ClassAction["CREATE"] = "CREATE";
    ClassAction["DELETE_BY_ID"] = "DELETE_BY_ID";
    ClassAction["DUPLICATE"] = "DUPLICATE";
    ClassAction["FIND_ALL"] = "FIND_ALL";
    ClassAction["GET_BY_ID"] = "GET_BY_ID";
    ClassAction["SORT"] = "SORT";
    ClassAction["UPDATE"] = "UPDATE";
    ClassAction["UPDATE_BATCH"] = "UPDATE_BATCH";
})(ClassAction || (ClassAction = {}));
export var EntityAction;
(function (EntityAction) {
    EntityAction["READ"] = "READ";
    EntityAction["READ_TREE"] = "READ_TREE";
    EntityAction["UPDATE"] = "UPDATE";
    EntityAction["UPDATE_TREE"] = "UPDATE_TREE";
    EntityAction["DELETE"] = "DELETE";
    EntityAction["DELETE_TREE"] = "DELETE_TREE";
    EntityAction["OWNER"] = "OWNER";
})(EntityAction || (EntityAction = {}));
export var TagClassPermission;
(function (TagClassPermission) {
    TagClassPermission["CREATE"] = "CLASS.TAG.CREATE";
    TagClassPermission["DELETE_BY_ID"] = "CLASS.TAG.DELETE_BY_ID";
    TagClassPermission["FIND_ALL"] = "CLASS.TAG.FIND_ALL";
    TagClassPermission["GET_BY_ID"] = "CLASS.TAG.GET_BY_ID";
    TagClassPermission["UPDATE"] = "CLASS.TAG.UPDATE";
})(TagClassPermission || (TagClassPermission = {}));
export var ClusterClassPermission;
(function (ClusterClassPermission) {
    ClusterClassPermission["CREATE"] = "CLASS.SHEET_ROW.CREATE";
    ClusterClassPermission["DELETE_BY_ID"] = "CLASS.SHEET_ROW.DELETE_BY_ID";
    ClusterClassPermission["DUPLICATE"] = "CLASS.SHEET_ROW.DUPLICATE";
    ClusterClassPermission["FIND_ALL"] = "CLASS.SHEET_ROW.FIND_ALL";
    ClusterClassPermission["GET_BY_ID"] = "CLASS.SHEET_ROW.GET_BY_ID";
    ClusterClassPermission["UPDATE"] = "CLASS.SHEET_ROW.UPDATE";
    ClusterClassPermission["SEARCH"] = "CLASS.SHEET_ROW.SEARCH";
    ClusterClassPermission["MOVE"] = "CLASS.SHEET_ROW.MOVE";
})(ClusterClassPermission || (ClusterClassPermission = {}));
export var DocumentClassPermission;
(function (DocumentClassPermission) {
    DocumentClassPermission["CREATE"] = "CLASS.DOCUMENT.CREATE";
    DocumentClassPermission["DELETE_BY_ID"] = "CLASS.DOCUMENT.DELETE_BY_ID";
    DocumentClassPermission["DUPLICATE"] = "CLASS.DOCUMENT.DUPLICATE";
    DocumentClassPermission["FIND_ALL"] = "CLASS.DOCUMENT.FIND_ALL";
    DocumentClassPermission["GET_BY_ID"] = "CLASS.DOCUMENT.GET_BY_ID";
    DocumentClassPermission["UPDATE"] = "CLASS.DOCUMENT.UPDATE";
})(DocumentClassPermission || (DocumentClassPermission = {}));
export var FeaturePermission;
(function (FeaturePermission) {
    FeaturePermission["TAGS_IN_MODEL"] = "FEATURE.TAGS_IN_MODEL";
    FeaturePermission["CLUSTER_FLOW_ADD"] = "FEATURE.CLUSTER_FLOW_ADD";
    FeaturePermission["ADMINISTRATION_MENU"] = "FEATURE.ADMINISTRATION_MENU";
    FeaturePermission["YEAR_VERSION_LOCKS"] = "FEATURE.YEAR_VERSION_LOCKS";
    FeaturePermission["IMPORT"] = "FEATURE.IMPORT";
    FeaturePermission["USERS_GROUPS_MANAGEMENT"] = "FEATURE.USERS_GROUPS_MANAGEMENT";
    FeaturePermission["REMOTE_JOBS"] = "FEATURE.REMOTE_JOBS";
    FeaturePermission["ENTRY_LINKS"] = "FEATURE.ENTRY_LINKS";
    FeaturePermission["COMMENTS"] = "FEATURE.COMMENTS";
    FeaturePermission["TAGS_IN_NAVBAR"] = "FEATURE.TAGS_IN_NAVBAR";
    FeaturePermission["TAGS_SIDEBAR"] = "FEATURE.TAGS_SIDEBAR";
    FeaturePermission["CREDENTIALS"] = "FEATURE.CREDENTIALS";
    FeaturePermission["LIST_ITEM_DESCRIPTION"] = "FEATURE.LIST_ITEM_DESCRIPTION";
    FeaturePermission["LIST_ITEM_TAGS"] = "FEATURE.LIST_ITEM_TAGS";
    FeaturePermission["INPUT_SETUP"] = "FEATURE.INPUT_SETUP";
    FeaturePermission["AUDIT_LOGS"] = "FEATURE.AUDIT_LOGS";
})(FeaturePermission || (FeaturePermission = {}));
export var UserClassPermission;
(function (UserClassPermission) {
    UserClassPermission["CREATE"] = "CLASS.USER.CREATE";
    UserClassPermission["DELETE_BY_ID"] = "CLASS.USER.DELETE_BY_ID";
    UserClassPermission["FIND_ALL"] = "CLASS.USER.FIND_ALL";
    UserClassPermission["GET_BY_ID"] = "CLASS.USER.GET_BY_ID";
    UserClassPermission["UPDATE"] = "CLASS.USER.UPDATE";
})(UserClassPermission || (UserClassPermission = {}));
export var EntryLinkClassPermission;
(function (EntryLinkClassPermission) {
    EntryLinkClassPermission["CREATE"] = "CLASS.ENTRY_LINK.CREATE";
    EntryLinkClassPermission["DELETE"] = "CLASS.ENTRY_LINK.DELETE";
    EntryLinkClassPermission["GET"] = "CLASS.ENTRY_LINK.GET";
    EntryLinkClassPermission["UPDATE"] = "CLASS.ENTRY_LINK.UPDATE";
})(EntryLinkClassPermission || (EntryLinkClassPermission = {}));
export var CellClassPermission;
(function (CellClassPermission) {
    CellClassPermission["EDIT"] = "CLASS.CELL.EDIT";
})(CellClassPermission || (CellClassPermission = {}));
export var ENTRY_LINK_PERMISSIONS_TITLE_MAP = {
    'CLASS.ENTRY_LINK.CREATE': 'Create Entry Links',
    'CLASS.ENTRY_LINK.DELETE': 'Delete Entry Links',
    'CLASS.ENTRY_LINK.GET': 'Get Entry Links',
    'CLASS.ENTRY_LINK.UPDATE': 'Update Entry Links',
};
export var USER_CLASS_PERMISSIONS_TITLE_MAP = {
    'CLASS.USER.FIND_ALL': 'Find All Users',
    'CLASS.USER.GET_BY_ID': 'Get User',
    'CLASS.USER.CREATE': 'Create User',
    'CLASS.USER.UPDATE': 'Update User',
    'CLASS.USER.DELETE_BY_ID': 'Delete User',
};
export var FEATURE_PERMISSIONS_TITLE_MAP = {
    'FEATURE.TAGS_IN_MODEL': 'Database Objects in Model',
    'FEATURE.CLUSTER_FLOW_ADD': 'Row Add',
    'FEATURE.ADMINISTRATION_MENU': 'Administration Menu',
    'FEATURE.IMPORT': 'Import',
    'FEATURE.USERS_GROUPS_MANAGEMENT': 'Users & Groups Management',
    'FEATURE.YEAR_VERSION_LOCKS': 'Version & Year Locks',
    'FEATURE.REMOTE_JOBS': 'Remote Jobs',
    'FEATURE.COMMENTS': 'Comments',
    'FEATURE.TAGS_IN_NAVBAR': 'Database in Navbar',
    'FEATURE.TAGS_SIDEBAR': 'Database Sidebar',
    'FEATURE.CREDENTIALS': 'Credentials',
    'FEATURE.ENTRY_LINKS': 'Entry Links',
    'FEATURE.LIST_ITEM_DESCRIPTION': 'List Item Description',
    'FEATURE.LIST_ITEM_TAGS': 'List Item Database Objects',
    'FEATURE.INPUT_SETUP': 'Input Setup',
    'FEATURE.AUDIT_LOGS': 'View Audit Logs',
};
export var CELL_CLASS_PERMISSIONS_TITLE_MAP = {
    'CLASS.CELL.EDIT': 'Edit Cells',
};
export var TAG_CLASS_PERMISSIONS_TITLE_MAP = {
    'CLASS.TAG.CREATE': 'Create Database Object',
    'CLASS.TAG.DELETE_BY_ID': 'Delete Database Object',
    'CLASS.TAG.FIND_ALL': 'Find All Database Objects',
    'CLASS.TAG.GET_BY_ID': 'Get Database Object',
    'CLASS.TAG.UPDATE': 'Update Database Object',
};
export var SHEET_ROW_CLASS_PERMISSIONS_TITLE_MAP = {
    'CLASS.SHEET_ROW.CREATE': 'Create Row',
    'CLASS.SHEET_ROW.DELETE_BY_ID': 'Delete Row',
    'CLASS.SHEET_ROW.DUPLICATE': 'Duplicate Row',
    'CLASS.SHEET_ROW.FIND_ALL': 'Find All Row',
    'CLASS.SHEET_ROW.GET_BY_ID': 'Get Row',
    'CLASS.SHEET_ROW.UPDATE': 'Update Row',
    'CLASS.SHEET_ROW.SEARCH': 'Search Row',
    'CLASS.SHEET_ROW.MOVE': 'Move Row',
};
export var DOCUMENT_CLASS_PERMISSIONS_TITLE_MAP = {
    'CLASS.DOCUMENT.CREATE': 'Create Document',
    'CLASS.DOCUMENT.DELETE_BY_ID': 'Delete Document',
    'CLASS.DOCUMENT.DUPLICATE': 'Duplicate Document',
    'CLASS.DOCUMENT.FIND_ALL': 'Find All Documents',
    'CLASS.DOCUMENT.GET_BY_ID': 'Get Document',
    'CLASS.DOCUMENT.UPDATE': 'Update Document',
};
function createPermissionMap(type, actions) {
    var e_1, _a;
    var permissionMap = {};
    try {
        for (var actions_1 = __values(actions), actions_1_1 = actions_1.next(); !actions_1_1.done; actions_1_1 = actions_1.next()) {
            var action = actions_1_1.value;
            permissionMap[action] = "".concat(type, ".").concat(action);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (actions_1_1 && !actions_1_1.done && (_a = actions_1.return)) _a.call(actions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return permissionMap;
}
export function createClassPermissionsMap(type) {
    var actions = Object.values(ClassAction);
    var classPermissionsMap = createPermissionMap(type, actions);
    return Object.freeze(classPermissionsMap);
}
export function createEntityPermissionsMap(type) {
    var actions = Object.values(EntityAction);
    var entityPermissionsMap = createPermissionMap(type, actions);
    return Object.freeze(entityPermissionsMap);
}
var PermissionMapsByEntity = {};
var PermissionMapsByClass = {};
export function getEntityPermissionMap(type) {
    if (!PermissionMapsByEntity[type]) {
        PermissionMapsByEntity[type] = createEntityPermissionsMap(type);
    }
    return PermissionMapsByEntity[type];
}
export function getPermissionMapsByEntityType() {
    var e_2, _a;
    try {
        for (var _b = __values(Object.values(EntityType)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var type = _c.value;
            if (!PermissionMapsByEntity[type]) {
                PermissionMapsByEntity[type] = createEntityPermissionsMap(type);
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return PermissionMapsByEntity;
}
export function getClassPermissionMap(type) {
    if (!PermissionMapsByClass[type]) {
        PermissionMapsByClass[type] = createClassPermissionsMap(type);
    }
    return PermissionMapsByClass[type];
}
export function getPermissionMapsByClassType() {
    var e_3, _a;
    try {
        for (var _b = __values(Object.values(ClassType)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var type = _c.value;
            if (!PermissionMapsByClass[type]) {
                PermissionMapsByClass[type] = createClassPermissionsMap(type);
            }
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return PermissionMapsByClass;
}
export function removePermissionsFromItem(command) {
    var item = command.item, permissions = command.permissions;
    var itemCopy = __assign({}, item);
    itemCopy.permissions = itemCopy.permissions.filter(function (rp) { return !permissions.some(function (p) { return p.name === rp.name && p.targetId === rp.targetId; }); });
    return itemCopy;
}
export function addPermissionsToItem(command) {
    var item = command.item, permissions = command.permissions;
    var itemCopy = __assign({}, item);
    itemCopy.permissions = __spreadArray(__spreadArray([], __read(itemCopy.permissions), false), __read(permissions), false);
    return itemCopy;
}
function toActionsByEntityIdMap(map, action) {
    map[action.id] = action;
    return map;
}
export function selectActionsByEntityId(actions) {
    return actions.reduce(toActionsByEntityIdMap, {});
}
